import {
  required,
  numeric,
  email,
  minLength,
  maxLength
} from "vuelidate/lib/validators";
export default {
  candidate: {
    first_name: {
      required
    },
    last_name: {
      required
    },
    last_name2: {
      required
    },
    email: {
      required,
      email
    },
    phone: {
      required,
      numeric,
      minLength: minLength(10),
      maxLength: maxLength(10)
    }
  },
  cvname: {
    required
  }
};
